/**
 * Helpers for identifying uniqueness in
 * in data and content
 */

import { DataRows } from '../domain/content/entities/valueobjects/DataRows';
import { DataSetFields } from '../domain/content/entities/valueobjects/Fields';

export const compareFieldTypeOrder = (a, b) => {
  if (a.order > b.order) return -1;
  if (a.order < b.order) return 1;
  return 0;
};

/**
 * without the context of a visual we just find the best uniqueness if possible for a given dataset and
 * content with fields
 * @param {*} content
 * @param {*} data
 */
export const findBestUniquenessFieldNames = (content, data) => {
  let uniqueFieldNames = [];
  let unique = false;
  const possibleFields = getSortedFieldNamesForUnqiueness(content.typeSpecific.fields); //returns array of fieldObjects
  for (const field of possibleFields) {
    uniqueFieldNames.push(field.fieldName);
    const isUnique = checkUniqueness(data, uniqueFieldNames, content.typeSpecific.fields);
    if (isUnique) {
      unique = true;
      break;
    }
  }
  if (unique && uniqueFieldNames.length > 1) {
    //backtrack uniqueness check
    //we have a visualConfiguration that is valid
    //get the fields used
    let validFieldNames = JSON.parse(JSON.stringify(uniqueFieldNames));
    //can we remove some fields
    for (const fieldName of validFieldNames) {
      const backUp = JSON.parse(JSON.stringify(validFieldNames));
      const filterIndex = backUp.findIndex((el) => el.fieldName === fieldName);
      if (filterIndex > -1) {
        backUp.splice(filterIndex, 1);
        const isUnique = checkUniqueness(data, backUp, content.typeSpecific.fields);
        if (isUnique) {
          validFieldNames = backUp;
        }
      }
    }
    uniqueFieldNames = validFieldNames;
  }
  return {
    unique: unique,
    fieldNames: uniqueFieldNames,
  };
};

export const getSortedFieldNamesForUnqiueness = (fields) => {
  return Object.keys(fields)
    .filter((el) => fields[el].fieldType === 'miscField' || fields[el].fieldType === 'timeField' || fields[el].fieldType === 'isoLabelField')
    .map((el) => {
      let order = 0;
      if (fields[el].fieldType === 'isoLabelField') order = 3;
      if (fields[el].fieldType === 'timeField') order = 2;
      if (fields[el].fieldType === 'miscField') order = 1;
      return { fieldName: fields[el].fieldName, title: fields[el].title, order: order };
    })
    .sort(compareFieldTypeOrder);
};

/**
 *
 * checks if data is unique with a list of fieldNames
 * this only works with simple types ( no geo or point)
 * @param  {any} data          [description]
 * @param  {any} fieldNames    [description]
 * @return {any}               [description]
 */

export const checkUniqueness = (data: DataRows, fieldNames: string[], fields: DataSetFields) => {
  const testFields = fieldNames.map((fieldName) => fields[fieldName]);
  const hashSet = new Set();
  for (let idx = 0; idx < data.length; idx++) {
    const row = data[idx];
    // const rowHash = fieldNames.map(fieldName => row[fieldName]).join('-');
    const rowHash = testFields.map((field) => (field.isoIsoField && row[field.isoIsoField] ? row[field.isoIsoField] : row[field.fieldName])).join('-');
    if (hashSet.has(rowHash)) return false;
    hashSet.add(rowHash);
  }

  return true;
};
